import api from './api';
// Explicit, admin-only server namespace; client flags never grant access.
export const privateStudyApi = {
  get: (path, ...args) => api.get(`/admin/preview${path}`, ...args),
  post: (path, ...args) => api.post(`/admin/preview${path}`, ...args),
  delete: (path, ...args) => api.delete(`/admin/preview${path}`, ...args),
};
